import Vue from 'vue'
import VueCompositionAPI from '@vue/composition-api'
import App from './App'
import router from './router'
import axios from 'axios'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 添加 echarts 图表
import * as echarts from 'echarts'
import 'echarts/map/js/china'
import * as echartsGL from 'echarts-gl'
// 高德地图
import AmapVue from '@amap/amap-vue'

Vue.prototype.$http = axios
Vue.prototype.$echarts = echarts // 引入echarts
Vue.prototype.$echartsGL = echartsGL // 引入组件（将echarts注册为全局）

AmapVue.config.version = '2.0' // 默认2.0，这里可以不修改
AmapVue.config.key = '308575e4767460a523a9aaf70d4ff268'
AmapVue.config.plugins = [
    'AMap.ToolBar',
    'AMap.MoveAnimation',
    'AMap.InfoWindow'
]

Vue.use(VueCompositionAPI)
Vue.use(ElementUI)
Vue.use(AmapVue)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: {App},
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js